import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import { Alert, Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { Icon } from '@flecto/ui'

import { useFormContext } from './AddressForm'

export const AddressWarnings = () => {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_locations' })
  const form = useFormContext()

  return (
    form.values.main && (
      <Alert
        mb='md'
        color='blue'
        title={t('alert_title')}
        icon={<Icon icon={faInfoCircle} />}
      >
        <Text c='blue.7' fw={400}>
          {t('alert_description')}
        </Text>
      </Alert>
    )
  )
}
